import React from 'react'

function StatusRenderer(props) {
  const status = props.data["Status"]

  let label = ""
  let statusClass = "";
  switch (status) {
    case 0:
      statusClass = "status-draft";
      label = "Draft";
      break;
    case 1:
      statusClass = "status-approved";
      label = "Approved";
      break;
    case 2:
      statusClass = "status-archived";
      label = "Archived";
      break;
    default:
      break;
  }

  return (
    <div className={`d-flex justify-content-center align-items-center status-container ${statusClass}`}>
      <p className='status-text mb-0 fw-bold'>{label.toUpperCase()}</p>
    </div>
  )
}

export default StatusRenderer